import { SearchIcon } from '@/components/icons'
import { platformBlock, platformMeta } from '@/blocks/platform-tools'
import type { BlockConfig, BlockMeta } from '@/blocks/types'
import { AuthMode, IntegrationType } from '@/blocks/types'

const SerpApiBlockOriginal: BlockConfig = {
  type: 'serpapi',
  name: 'SerpApi',
  description: 'Read Google results, YouTube metadata and transcripts',
  authMode: AuthMode.ApiKey,
  category: 'tools',
  integrationType: IntegrationType.Search,
  bgColor: 'var(--text-tertiary)',
  icon: SearchIcon,
  subBlocks: [
    {
      id: 'operation',
      title: 'Operation',
      type: 'dropdown',
      value: () => 'google_search',
      options: [
        { id: 'google_search', label: 'Google Search' },
        { id: 'youtube_data', label: 'YouTube Metadata' },
        { id: 'youtube_video_transcript', label: 'YouTube Transcript' },
      ],
    },
    { id: 'apiKey', title: 'API Key', type: 'short-input', password: true, required: true },
    { id: 'parameters', title: 'Parameters (JSON)', type: 'code', required: true },
  ],
  tools: {
    access: ['serpapi_google_search', 'serpapi_youtube_data', 'serpapi_youtube_video_transcript'],
    config: {
      params: (p) => ({
        apiKey: p.apiKey,
        parameters:
          typeof p.parameters === 'string' ? JSON.parse(p.parameters || '{}') : p.parameters,
      }),
      tool: (p) => `serpapi_${p.operation || 'google_search'}`,
    },
  },
  inputs: {
    apiKey: { type: 'string', description: 'API key' },
    parameters: { type: 'string', description: 'JSON request parameters' },
  },
  outputs: { data: { type: 'json', description: 'Provider data' } },
}
const SerpApiBlockMetaOriginal = { tags: ['marketing'], templates: [] } satisfies BlockMeta

export const SerpApiBlock = platformBlock(SerpApiBlockOriginal)
export const SerpApiBlockMeta = platformMeta(SerpApiBlockMetaOriginal)
